import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function PayPalSubscribeButton({ onProcessing }) {
  const { user } = useAuth();
  const ref = useRef(null);

  useEffect(() => {
    if (!window.paypal || !ref.current || !user) return;
    let buttonsInstance;
    try {
      // Clear any previously rendered content (handles StrictMode double mount)
      ref.current.innerHTML = '';
      buttonsInstance = window.paypal.Buttons({
        style: {
          shape: 'rect',
          color: 'gold',
          layout: 'vertical',
          label: 'subscribe',
        },
        createSubscription: (data, actions) =>
          actions.subscription.create({
            plan_id: 'P-41T18070M48727934NCNAP2Q',
          }),
        onApprove: async (data) => {
          try {
            if (typeof onProcessing === 'function') onProcessing();
          } catch (_) {}
          await fetch('/paypal/subscribe', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              uid: user.uid,
              subscriptionId: data.subscriptionID,
            }),
          });
        },
      });
      buttonsInstance.render(ref.current);
    } catch (e) {
      console.error('PayPal button error', e);
    }
    return () => {
      try {
        if (buttonsInstance && buttonsInstance.close) {
          buttonsInstance.close();
        }
      } catch (_) {}
      if (ref.current) ref.current.innerHTML = '';
    };
  }, [user]);

  return <div ref={ref} />;
}
